import React from 'react'

import SearchHits from './SearchHits'

export default class SearchEvents extends React.PureComponent {

  render(){
    return (
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flexGrow:1, display: 'flex', flexDirection: 'row', paddingTop: 14, paddingBottom: 14, backgroundColor: '#fafafa', fontSize: 14, justifyContent: 'space-between' }}>
          <div style={{ width: 200, justifyContent:'flex-start' }}>
            Date
          </div>
          <div style={{ width: 200, justifyContent:'flex-start' }}>
            Job Name
          </div>
          <div style={{ width: 200, justifyContent:'flex-start' }}>
            Customer Info
          </div>
          <div style={{ width: 200, justifyContent:'flex-start' }}>
            Address
          </div>
          <div style={{ width: 200, justifyContent:'flex-start' }}>
            Crew
          </div>
        </div>
        <SearchHits />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/schedule/search/SearchEvents.js